import { Handyman } from "@mui/icons-material";

export default function MaintenanceUnderConstruction() {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column"
            }}
        >
            <h1>Coming Soon</h1>
            <Handyman sx={{ fontSize: 28 }} />
        </div>
    );
}
